import { createSlice } from "@reduxjs/toolkit";

interface ModalState{
    isOpen:boolean,
    dailogType:string | null,
    isTestCompletedDialogClosed:boolean,
}

const initialState:ModalState={
    isOpen:false,
    dailogType:null,
    isTestCompletedDialogClosed : false,
}


const dialogSlice = createSlice({
    name:"dialog",
    initialState,
    reducers:{
        openDialog:(state,action) => {
            state.isOpen = true;
            state.dailogType = action.payload;
        },
        closeDialog:(state) => {
            state.isOpen = false;
            state.dailogType = null;
        },
        setIsTestCompletedDialogClosed:(state,action) => {
            state.isTestCompletedDialogClosed = action.payload;
        }
    }
})
export const selectDialogType = (state: { dialog: ModalState }) => state.dialog.dailogType; // Using your spelling
export const {openDialog,closeDialog,setIsTestCompletedDialogClosed} = dialogSlice.actions;
export default  dialogSlice.reducer